<script setup lang="ts">
/**
 * Static label pill — board, level, mode, "Focus goal met".
 *
 * Not interactive. For a togglable filter use {@link RlChip}; conflating the
 * two is how you end up with a label that looks clickable.
 */
withDefaults(
  defineProps<{ tone?: "neutral" | "success" | "info" | "warn" | "accent" }>(),
  { tone: "neutral" },
);
</script>

<template>
  <span class="pill" :class="`pill-${tone}`"><slot /></span>
</template>

<style scoped>
.pill {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-1);
  padding: 2px var(--sp-2);
  font-size: var(--rl-text-xs);
  font-weight: 500;
  white-space: nowrap;
  border: 1px solid transparent;
  border-radius: var(--radius-pill);
}

.pill-neutral {
  color: var(--rl-fg-2);
  background: var(--rl-bg-muted);
  border-color: var(--rl-border-subtle);
}

.pill-success {
  color: var(--rl-success-fg);
  background: var(--rl-success-bg);
  border-color: var(--rl-success-bd);
}

.pill-info {
  color: var(--rl-info-fg);
  background: var(--rl-info-bg);
  border-color: var(--rl-info-bd);
}

.pill-warn {
  color: var(--rl-warn-fg);
  background: var(--rl-warn-bg);
  border-color: var(--rl-warn-bd);
}

.pill-accent {
  color: var(--rl-green-700);
  background: var(--rl-green-100);
  border-color: var(--rl-green-200);
}
</style>
